import React from 'react';
import Gap from '@boschebike/ebds-react/dist-esm/components/Gap.js';
/**
 * @typedef {import('../../App.d.ts').GapProps} GapProps
 */
/**
 *
 * @param {GapProps} props
 * @returns {Element}
 * @constructor
 */
export default (props) => (
  <Gap
    data-testid="gap"
    left={String(props.left)}
    right={String(props.right)}
    top={String(props.top)}
    bottom={String(props.bottom)}
  />
);
